import { format } from 'date-fns';

function formatDate (actualDate, formatStr) {
   if (typeof actualDate !== 'undefined') {
       if (formatStr !== "") {
           return format(String(actualDate), formatStr);
       }
       return format(String(actualDate), 'DD/MM/YYYY HH:mm');
   }
   return "";
}

export default formatDate;
